<template>
    <div>
        <h3>{{ $t('login') }}</h3>
        <form @submit="login">
            <label class="form-label" for="username">{{ $t('username') }}</label>
            <input class="form-control" type="text" id="username" v-model="username" required>
            <br>
            <label class="form-label" for="password">{{ $t('password') }}</label>
            <input class="form-control" type="password" id="password" v-model="password" required>
            <br>
            <button class="btn btn-primary" type="submit">{{ $t('login') }}</button>
            <div>
                <p>{{ error }}</p>
            </div>
        </form>
    </div>
</template>

<script>
import { mapActions } from 'vuex';

export default {
    name: 'LoginForm',
    data() {
        return {
            username: '',
            password: '',
            error: ''
        };
    },
    methods: {
        ...mapActions(['updateUsername']),
        async login(event) {
            event.preventDefault();

            try {
                // Make a request to the backend API for login
                const response = await fetch(`${this.$url}/login`, {
                    method: 'POST',
                    headers: {
                        'Content-Type': 'application/json',
                    },
                    body: JSON.stringify({
                        username: this.username,
                        password: this.password
                    })
                });
                if (response.ok) {
                    this.error = '';
                    // Login successful, parse the response body as JSON
                    const data = await response.json();
                    //const isAdmin = data.isAdmin;

                    // Get the token from the parsed response body
                    let token = data.token;

                    // Create a cookie for the user
                    document.cookie = 'token=' + token + '; path=/';

                    // Update username in the Vuex store
                    this.updateUsername(this.username);

                    this.$router.push('/home');
                } else {
                    // Handle login error, display an error message, etc.
                    console.error('Login failed');
                    const errorData = await response.json();
                    this.error = errorData.error || response.statusText;
                }
            } catch (error) {
                // Handle network error, display an error message, etc.
                console.error('Network error:', error);
                this.error = 'An error occurred while trying to log in.';
            }
        }
    }
};
</script>

<style>
/* Add your component-specific styles here */
</style>